import { cnBem } from '@carnica/utils';
import lightTheme from "../styles/color/light-palette.pcss";
import darkTheme from "../styles/color/dark-palette.pcss";
var cnLightTheme = cnBem('theme-light', lightTheme);
var cnDarkTheme = cnBem('theme-dark', darkTheme);
var getCn = function getCn(theme) {
  if (theme === 'dark') {
    return cnDarkTheme;
  }
  return cnLightTheme;
};
export var cnTheme = function cnTheme(theme) {
  return getCn(theme)();
};